import Scan from "~/components/organisms/Scan/Scan";

const HAIR_SCAN_TYPE = "hair";

const FollicleScan = () => {
  return <Scan type={HAIR_SCAN_TYPE} />;
};
export default FollicleScan;
